/* ===================================================================
   Aide au choix de la taille — web component <size-advisor>
   Toutes les règles viennent des attributs data-* (configurables par
   produit dans l'éditeur de thème). Aucune règle codée en dur ici.
   =================================================================== */
if (!customElements.get('size-advisor')) {
  customElements.define(
    'size-advisor',
    class SizeAdvisor extends HTMLElement {
      connectedCallback() {
        this.usual = this.querySelector('[data-usual]');
        this.result = this.querySelector('[data-result]');
        this.widthInputs = this.querySelectorAll('[data-width]');
        if (!this.usual || !this.result) return;

        this.onChange = this.update.bind(this);
        this.usual.addEventListener('change', this.onChange);
        this.widthInputs.forEach((el) => el.addEventListener('change', this.onChange));
      }

      disconnectedCallback() {
        if (!this.usual) return;
        this.usual.removeEventListener('change', this.onChange);
        this.widthInputs.forEach((el) => el.removeEventListener('change', this.onChange));
      }

      num(attr, fallback) {
        const v = parseFloat(this.dataset[attr]);
        return isNaN(v) ? fallback : v;
      }

      selectedWidth() {
        let val = 'standard';
        this.widthInputs.forEach((el) => {
          if (el.checked) val = el.value;
        });
        return val;
      }

      format(n) {
        // Affiche un entier sans décimale, sinon garde une demi-pointure
        return Number.isInteger(n) ? String(n) : n.toFixed(1).replace('.0', '');
      }

      update() {
        const usual = parseFloat(this.usual.value);
        if (isNaN(usual)) {
          this.result.textContent = this.dataset.msgPrompt || 'Sélectionnez votre pointure habituelle.';
          this.result.hidden = false;
          return;
        }

        const fit = this.dataset.fit || 'true_to_size';
        const width = this.selectedWidth();

        let adjust = 0;
        let fitMsg = this.dataset.msgTrue || '';
        if (fit === 'runs_small') {
          adjust += this.num('adjustSmall', 1);
          fitMsg = this.dataset.msgSmall || '';
        } else if (fit === 'runs_large') {
          adjust += this.num('adjustLarge', -1);
          fitMsg = this.dataset.msgLarge || '';
        }

        let widthMsg = '';
        if (width === 'wide') {
          adjust += this.num('adjustWide', 0);
          widthMsg = this.dataset.adviceWide || '';
        } else if (width === 'narrow') {
          adjust += this.num('adjustNarrow', 0);
          widthMsg = this.dataset.adviceNarrow || '';
        }

        let rec = usual + adjust;

        // Bornage à la plage de pointures disponibles (si fournie)
        const sizes = (this.dataset.sizes || '')
          .split(',')
          .map((s) => parseFloat(s.trim()))
          .filter((n) => !isNaN(n));
        if (sizes.length) {
          const min = Math.min(...sizes);
          const max = Math.max(...sizes);
          if (rec < min) rec = min;
          if (rec > max) rec = max;
        }

        const label = this.dataset.recommendLabel || 'Notre recommandation';
        let out = label + ' : du ' + this.format(rec) + '.';
        if (fitMsg) out += ' ' + fitMsg;
        if (widthMsg) out += ' ' + widthMsg;

        this.result.textContent = out;
        this.result.hidden = false;
      }
    }
  );
}
